import {
  CHANGE_DISTRICTS_COUNTRY_FILTER,
  CHANGE_DISTRICTS_FILTERS,
  CHANGE_DISTRICTS_PAGE,
  CHANGE_DISTRICTS_STATE_FILTER,
} from './actions'

export const initialState = () => ({
  countryCode: '',
  stateId: '',
  page: 0,
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_DISTRICTS_COUNTRY_FILTER:
      return {
        ...state,
        countryCode: action.payload,
      }

    case CHANGE_DISTRICTS_STATE_FILTER:
      return {
        ...state,
        stateId: action.payload,
      }

    case CHANGE_DISTRICTS_FILTERS:
      return {
        ...state,
        ...action.payload,
      }

    case CHANGE_DISTRICTS_PAGE:
      return {
        ...state,
        page: action.payload,
      }

    default:
      return state
  }
}
